import { Avatar, AvatarShape, Column, Space, Text } from 'farmhub-ui-core';

import { TitleText } from 'components';

import { Wrapper, WrapperAvatar } from './styles';

interface EntityCardProps {
  onClick: (e: any) => void;
  item: any;
  disabled?: boolean;
}

const EntityCardDesktop = ({
  item,
  onClick,
  disabled,
}: EntityCardProps): JSX.Element => (
  <Wrapper isAtModal disabled={disabled} onClick={onClick}>
    <WrapperAvatar background={item.background}>
      <Avatar shape={AvatarShape.Square} size={48} src={item.avatar} />
    </WrapperAvatar>
    <Space width={18} />
    <Column>
      <TitleText color="dark">{item.name}</TitleText>
      <Space height={4} />
      <Text lineNumber={3}>{item.description}</Text>
    </Column>
  </Wrapper>
);

export default EntityCardDesktop;
